export const SUPPORTED_PARTNERS = [{ code: 'ONE_MONEY', label: 'One Money' }];

export const CSV_COLUMN_SOURCE_ACCOUNT_NUMBER = 'source_account_number';
export const CSV_COLUMN_BENEFICIARY_NAME = 'beneficiary_name';
export const CSV_COLUMN_BENEFICIARY_ACCOUNT_NUMBER = 'beneficiary_account_number';
export const CSV_COLUMN_AMOUNT = 'amount';
export const CSV_COLUMN_CURRENCY = 'currency';
export const CSV_COLUMN_PURPOSE = 'purpose';
export const CSV_COLUMN_REFERENCE = 'reference';
export const CSV_COLUMN_CREATE_CREDIT_RECORD = 'create_credit_record';

export const CSV_BOOLEAN_TRUE_VALUES = ['true', 'yes', 'y', '1'];
export const CSV_BOOLEAN_FALSE_VALUES = ['false', 'no', 'n', '0'];

export type BulkTransferCsvColumn = {
  key: string;
  isRequired: boolean;
};

export const BULK_TRANSFER_CSV_COLUMNS: BulkTransferCsvColumn[] = [
  { key: CSV_COLUMN_SOURCE_ACCOUNT_NUMBER, isRequired: true },
  { key: CSV_COLUMN_BENEFICIARY_NAME, isRequired: false },
  { key: CSV_COLUMN_BENEFICIARY_ACCOUNT_NUMBER, isRequired: true },
  { key: CSV_COLUMN_AMOUNT, isRequired: true },
  { key: CSV_COLUMN_CURRENCY, isRequired: true },
  { key: CSV_COLUMN_PURPOSE, isRequired: true },
  { key: CSV_COLUMN_REFERENCE, isRequired: false },
  { key: CSV_COLUMN_CREATE_CREDIT_RECORD, isRequired: false },
];

export const MAX_BULK_TRANSFER_ROWS = 1000;

export const BULK_TRANSFER_CHUNK_SIZE = 10;

export const BULK_TRANSFER_ROW_STATUS_SUCCEEDED = 'succeeded';
export const BULK_TRANSFER_ROW_STATUS_FAILED = 'failed';
export const BULK_TRANSFER_ROW_STATUS_NOT_PROCESSED = 'not_processed';

export const BULK_TRANSFER_SAMPLE_FILE_NAME = 'bulk-partner-account-transfer-sample.csv';
export const BULK_TRANSFER_RESULTS_FILE_NAME = 'bulk-partner-account-transfer-results.csv';

export const CURRENCY_CODE_PATTERN = /^[A-Z0-9]{3,6}$/;
export const MAX_CURRENCY_CODE_LENGTH = 6;
